import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useOnboarding } from "./OnboardingContext";
import { getOnboardingStepIndexFromPath, ONBOARDING_STEPS } from "./onboardingDraft";
import { OnboardingWizardChrome, OnboardingWizardFooter } from "./OnboardingWizard";
import StepPhotos from "./steps/StepPhotos";
import StepBasicProfile from "./steps/StepBasicProfile";
import StepProfileInfo from "./steps/StepProfileInfo";
import StepServices from "./steps/StepServices";
import StepContact from "./steps/StepContact";
import "./OnboardingTrain.css";

const TRAIN_STEPS = [
  { key: "photos", Component: StepPhotos },
  { key: "profile", Component: StepBasicProfile },
  { key: "info", Component: StepProfileInfo },
  { key: "services", Component: StepServices },
  { key: "contact", Component: StepContact },
];

export default function OnboardingTrain() {
  const location = useLocation();
  const navigate = useNavigate();
  const { goToPrevStep, saveToastVisible } = useOnboarding();
  const pathIndex = getOnboardingStepIndexFromPath(location.pathname);
  const activeIndex = pathIndex < 0 ? 0 : pathIndex;
  const [transitionEnabled, setTransitionEnabled] = useState(false);

  useEffect(() => {
    if (pathIndex < 0) {
      navigate("/onboarding/photos", { replace: true, state: location.state });
    }
  }, [pathIndex, navigate, location.state]);

  useEffect(() => {
    const enableTimer = window.setTimeout(() => {
      setTransitionEnabled(true);
    }, 32);

    return () => window.clearTimeout(enableTimer);
  }, []);

  useEffect(() => {
    if (transitionEnabled) return undefined;

    const recoverTimer = window.setTimeout(() => {
      setTransitionEnabled(true);
    }, 48);

    return () => window.clearTimeout(recoverTimer);
  }, [transitionEnabled]);

  const activeStep = ONBOARDING_STEPS[activeIndex];

  const handleBack = () => {
    if (activeStep?.key) {
      goToPrevStep(activeStep.key);
    }
  };

  return (
    <div className="onboarding-wizard onboarding-wizard--train">
      <div className="onboarding-wizard__shell">
        <OnboardingWizardChrome stepIndex={activeIndex} onBack={handleBack} />

        <div className="onboarding-train-viewport">
          <div
            className={`onboarding-train${transitionEnabled ? " onboarding-train--animate" : ""}`}
            style={{ transform: `translate3d(-${activeIndex * 100}%, 0, 0)` }}
          >
            {TRAIN_STEPS.map((step, index) => {
              const Step = step.Component;
              const isActive = index === activeIndex;

              return (
                <div
                  key={step.key}
                  className="onboarding-train__car"
                  aria-hidden={!isActive}
                >
                  <Step />
                </div>
              );
            })}
          </div>
        </div>

        <OnboardingWizardFooter />
      </div>

      {saveToastVisible ? (
        <div className="onboarding-save-toast" role="status" aria-live="polite">
          Profile updated successfully
        </div>
      ) : null}
    </div>
  );
}
